import React from "react";

import "./CookieListItem.scss";

type CookieListItemProps = {
  name: string;
  provider: string;
  purpose: string;
  type: string;
  duration: string;
};

const CookieListItem: React.FC<CookieListItemProps> = ({
  name,
  provider,
  purpose,
  type,
  duration
}: CookieListItemProps) => {
  return (
    <div className="cookie-list-item">
      <div
        className="cookie-list-item__name"
        data-test-id="cookieSettings-name"
      >
        {name}
      </div>
      <div data-test-id="cookieSettings-provider">{provider}</div>
      <div data-test-id="cookieSettings-purpose">{purpose}</div>
      <div data-test-id="cookieSettings-type">{type}</div>
      <div data-test-id="cookieSettings-duration">{duration}</div>
    </div>
  );
};

export default CookieListItem;
